<!--
  ~ Copyright (C) 2020 - present by OpenGamma Inc. and the OpenGamma group of companies
  ~
  ~ Please see distribution for license.
  -->

<span [matTooltip]="value | number: '1.2-2'" matTooltipPosition="right">
  {{ value | boundedShortNumber: value:'1.0-2' }}
</span>
